// extracted by mini-css-extract-plugin
export default {"form":"EditForm_form__50y2U","leftColumn":"EditForm_leftColumn__-jxSQ","rightColumn":"EditForm_rightColumn__Plx9E"};